<template>
  <svg preserveAspectRatio="xMidYMid" :viewBox="viewBox" aria-hidden='true'>
    <g :transform="transform">
      <g style="fill:none;stroke:rgb(1,0,0);stroke-width:0.050000;stroke-linecap:round">
        <g v-for="county in counties" :key="county.id">
          <path
            v-for="(path, idx) in county.paths"
            :key="idx"
            :d="path"
            :fill="county.fill"
            @click="toggleCounty(county.id)">
            <title>{{ county.name }} County</title>
          </path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'county-map',
  props: ['counties', 'viewBox', 'transform'],
  methods: {
    toggleCounty (id) {
      this.$emit('county-clicked', id)
    }
  }
}
</script>
